import { PayloadAction } from '@reduxjs/toolkit'
import { IRequestByPartnerId } from 'legacy/lut/classes/models/service'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { IPartnerFlag, IPartnerFlags } from 'clickNgo/entities/partner/models/partnerFlag'

import { IPartnerState } from '../models'

export const getPartnerFlagsByIdPending = (
  state: IPartnerState,
  action: PayloadAction<undefined, string, { arg: IRequestByPartnerId }>
) => {
  const { meta } = action
  const status = RequestStatus.PENDING
  const message = `Partner flags are loading for ${meta.arg}`

  const accreditation: IPartnerFlag[] = []
  const program: IPartnerFlag[] = []
  const agreement: IPartnerFlag[] = []

  state.partnerFlags = {
    meta,
    status,
    message,
    accreditation,
    agreement,
    program,
  }
}

export const getPartnerFlagsByIdRejected = (
  state: IPartnerState,
  action: PayloadAction<unknown, string, { arg: IRequestByPartnerId }>
) => {
  const { meta } = action
  const status = RequestStatus.REJECTED
  const message = `Partner flags are failed for ${meta.arg}`
  const accreditation: IPartnerFlag[] = []
  const program: IPartnerFlag[] = []
  const agreement: IPartnerFlag[] = []

  state.partnerFlags = {
    meta,
    status,
    message,
    accreditation,
    agreement,
    program,
  }
}

export const getPartnerFlagsByIdFulfilled = (
  state: IPartnerState,
  action: PayloadAction<IPartnerFlags, string, { arg: IRequestByPartnerId }>
) => {
  const { meta, payload } = action
  const { accreditation, agreement, program } = payload
  const status = RequestStatus.FULFILLED
  const message = `success`

  state.partnerFlags = {
    meta,
    status,
    message,
    accreditation,
    agreement,
    program,
  }
}
